import {
  FETCH_PURITY_REQUEST,
  FETCH_PURITY_SUCCESS, 
FETCH_PURITY_FAILURE,
ADD_PURITY_REQUEST,
ADD_PURITY_SUCCESS,
ADD_PURITY_FAILURE,
UPDATE_PURITY_REQUEST,
UPDATE_PURITY_SUCCESS,
UPDATE_PURITY_FAILURE,
DELETE_PURITY_REQUEST,
DELETE_PURITY_SUCCESS,
DELETE_PURITY_FAILURE,
PURITY_FORM_ERROR,
PURITY_FORM_SUCCESS,
SET_PURITY_EDIT,
CLEAR_PURITY_EDIT, 
} from '../../../../types/masters/styles/purity/purityTypes';

const initialState = {
  list: [],
  loading: false,
  error: null,
  editingPurity: null,
};

const purityReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PURITY_REQUEST:
    case ADD_PURITY_REQUEST:
    case UPDATE_PURITY_REQUEST:
    case DELETE_PURITY_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_PURITY_SUCCESS:
      return { ...state, loading: false, list: action.payload, error: null };
    case ADD_PURITY_SUCCESS:
    case UPDATE_PURITY_SUCCESS:
    case DELETE_PURITY_SUCCESS:
      return { ...state, loading: false, error: null };
    case FETCH_PURITY_FAILURE:
    case ADD_PURITY_FAILURE:
    case UPDATE_PURITY_FAILURE:
    case DELETE_PURITY_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case SET_PURITY_EDIT:
      return { ...state, editingPurity: action.payload };
    case CLEAR_PURITY_EDIT:
      return { ...state, editingPurity: null };
    default:
      return state;
  }
};

export default purityReducer; 